import React, { FC } from 'react';
import { useIconSizes } from './useIconSizes';
import { DEFAULT_HEIGHT, DEFAULT_WIDTH } from './const';
import { SvgComponentProps } from './types';

export const Svg: FC<SvgComponentProps> = ({
	height = DEFAULT_HEIGHT,
	width = DEFAULT_WIDTH,
	viewBox = '0 0 16 16',
	fill = 'currentColor',
	dataTestId,
	defs,
	children,
	...props
}) => {
	const sizes = useIconSizes({
		height,
		width,
	});

	return (
		<svg
			viewBox={viewBox}
			height={sizes.height}
			width={sizes.width}
			fill={fill}
			data-testid={dataTestId}
			{...props}
		>
			{children}
			{defs && <defs>{defs}</defs>}
		</svg>
	);
};
